import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center p-6">
      <div className="p-4 rounded-3xl bg-green-600/10 text-green-500 border border-green-600/20 mb-4">
        <ShieldAlert className="w-12 h-12" />
      </div>
      <h1 className="text-4xl font-extrabold text-white font-display">404 - Page Not Found</h1>
      <p className="text-sm text-slate-400 max-w-sm mt-2">
        The route or resource you are looking for does not exist in SuperAdmin control panel.
      </p>
      <button
        onClick={() => navigate('/dashboard')}
        className="mt-6 px-6 py-2.5 rounded-xl bg-green-700 hover:bg-green-600 text-white font-semibold text-xs shadow-lg shadow-green-700/30 flex items-center space-x-2 transition"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Return to Dashboard</span>
      </button>
    </div>
  );
};

export default NotFound;
